import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { AccountService } from '@application/services/account.service';
import { IconSetService } from '@coreui/icons-angular';
import { UserAccessService } from '@infrastructure/services/catalog/user-access.service';
import { KeycloakService } from 'keycloak-angular';
import { perfil, perfilUsarAccesoDe } from '@domain/models/_profile';
import { PermissionsService } from '@application/services/permissions.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public isLoading = true;
  public message = '';
  public progressValue = 0;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    private permissionsService: PermissionsService,
    private _serv: UserAccessService,
    private readonly keycloak: KeycloakService,
    public _http: HttpClient
  ) {}

  ngOnInit() {
    this.validateUser();
  }

  private async validateUser(): Promise<void> {
    this.message = 'Verificando inicio de session';
    await this.accountService.verifyLogin();
    await this.loadUserData();
    if (this.accountService.hasLogin()) {
      this.accountService.navigateToHome();
    } else {

    }
  }

  public reloadSession() {
    localStorage.clear();
    this.keycloak.clearToken();
    this.keycloak.logout();
  }

  private async loadUserData() {
    this.isLoading = true;
    this.progressValue = 0;
    this.message = 'Cargando Información del usuario';
    try {
      if (this.accountService.hasLogin()) {
        this.progressValue = 10;
        const userData = await this.keycloak.loadUserProfile();
        this.message = 'Obteniendo perfil del usuario';
        this.accountService.setUserData(userData);
        this.progressValue = 30;
        this.message = 'Validando usuario';
        this.message = 'Cargando permisos del usuario';
        await this.getPerfilUsuario(this.accountService.getUserData().id);
        this.progressValue = 50;
        this.message = 'Validando vigencia del usuario';
        await this.validaVigenciaUsuario(this.accountService.getUserData().id!);
        this.progressValue = 80;
        this.message = 'Usuario cargado correctamente';
        this.progressValue = 100;
        this.accountService.setIsLogin(true);
      } else {
        this.message = 'Token de sesión no valido';
        throw new Error('Token de sesión no valido');
      }
    } catch (error) {
      this.isLoading = false;
      this.accountService.setIsLogin(false);
      console.log(error);
    }
  }

  private async getPerfilUsuario(id: any): Promise<void> {
    try {
      localStorage.setItem('idUsuario', JSON.stringify(id)); // DEPRECATED
      const data$ = this._serv.findProfileByUser(id);
      const data = await lastValueFrom(data$);
      if (!data) {
        throw new Error('Usuario no encontrado');
      }
      console.log(data)
      const permissionsString: string[] = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if(index === 0){
          perfil.usuario.nombre = element.nombre;
        }
        permissionsString.push(element.producto + '-' + element.funcion);
      }
      this.permissionsService.setPermissions(permissionsString);

      localStorage.setItem('usuario', JSON.stringify(perfil.usuario));
      // END DEPRECATED OLD FUNCTIONS
    } catch (error) {
      this.message = 'No se pudo recuperar el perfil del usuario';
      throw error;
    }
  }

  validaVigenciaUsuario(userId: string) {
    return this._serv
      .validarVigenciaUsuarioPoIdUsuario(userId)
      .subscribe((s: any) => {
        if (s.error.codigo === '1012') {
          localStorage.clear();
          this.keycloak.logout();
        }
      });
  }
}
